import { Component, Input } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolBadge } from '../../../models/core/sol-badge';

@Component({
  selector: 'sol-badge',
  imports: [],
  templateUrl: './sol-badge.component.html',
  styles: [
    `
      :host {
        display: inline-flex;
      }
    `,
  ],
})
export class SolBadgeComponent extends AbstractComponent<SolBadge> {
  protected readonly visible$ = this.compute(state => state.visible);
  protected readonly displayCount$ = this.compute(state => state.displayCount);
  protected readonly backgroundColor$ = this.compute(state => state.backgroundColor);
  protected readonly countVisible$ = this.compute(state => state.countVisible);
  protected readonly dotVisible$ = this.compute(state => state.dotVisible);
  protected readonly inset$ = this.compute(state => state.placement === 'inset');
  protected readonly cutout$ = this.compute(state => state.visible && state.placement === 'corner');

  constructor() {
    super(SolBadge.of());
  }

  @Input()
  public set badge(badge: SolBadge) {
    this.patch(badge);
  }
}
